import type { ApercuImport } from '@ocerm/shared';

export type ModeSelectionImport = 'tous' | 'nouveaux' | 'aucun';

export function selectionImportPour(apercu: ApercuImport, mode: ModeSelectionImport): Set<number> {
  if (mode === 'aucun') return new Set();
  const contacts =
    mode === 'nouveaux' ? apercu.contacts.filter((c) => c.statut === 'nouveau') : apercu.contacts;
  return new Set(contacts.map((c) => c.index));
}
